/**
 * AuthGuard for SnapHub PWA.
 *
 * Provides authentication checks for the router by reading the access token
 * via the StorageAdapter. Protected routes require a valid (non-empty) token.
 *
 * Validates: Requirements 40.1, 40.2, 40.3
 */

import { storageAdapter } from './storage-adapter';

// Re-export the key so existing consumers (tests, etc.) still compile.
export { ACCESS_TOKEN_KEY } from './storage-adapter';

// ---------------------------------------------------------------------------
// Public API
// ---------------------------------------------------------------------------

/**
 * Returns `true` when a non-empty access token exists in SessionStorage.
 */
export function isAuthenticated(): boolean {
  const token = storageAdapter.getAccessToken();
  return token !== null && token.trim().length > 0;
}

/**
 * Reads the current access token from SessionStorage.
 * Returns `null` when no token is stored.
 */
export function getAccessToken(): string | null {
  return storageAdapter.getAccessToken();
}

/**
 * Stores an access token in SessionStorage.
 */
export function setAccessToken(token: string): void {
  storageAdapter.setAccessToken(token);
}

/**
 * Removes the access token from SessionStorage.
 */
export function clearAccessToken(): void {
  storageAdapter.clearAccessToken();
}
